import * as React from 'react';
import styles from './PinLink.module.css'; // Reuse the same styles as PinLink
import { useSelector } from 'react-redux';
import { selectDigitalMap } from 'ducks/universal/digitalMap';
import { useMapDisplayContext } from 'components/Map/MapDisplayContext';
import { smoothMoveCamera } from 'components/Map/mapUtils';

interface Props {
  menuItemKey: string | null;
  pinKey: string | null;
  children: React.ReactNode;
  onCloseChat: () => void;
}

export const MenuItemLink = ({ menuItemKey, pinKey, children, onCloseChat }: Props) => {
  const digitalMap = useSelector(selectDigitalMap);
  const {
    pushUrlParams,
    googleMap,
    openLayersMap,
    setActiveRestaurantId,
    setActiveItemSelection,
    setActiveRestaurantPageStack,
  } = useMapDisplayContext();

  const pin = pinKey ? digitalMap?.pins.find((pin) => pin.key === pinKey) : null;
  const restaurantId = pin?.online_order_restaurant_id || pin?.view_menu_restaurant_id;

  const handleClick = (e: React.MouseEvent) => {
    e.preventDefault();
    if (pinKey) {
      pushUrlParams({ pin: pinKey, pind: 'DETAILS', nav: 'map' });
      if (restaurantId) {
        setActiveRestaurantId(restaurantId);
        setActiveItemSelection({
          menuItemKey: menuItemKey ?? '',
          optionGroups: [],
          quantity: 1,
        });
        setActiveRestaurantPageStack(['MAIN', 'ITEM']);
      }
      onCloseChat();

      if (pin?.location) {
        smoothMoveCamera(googleMap, openLayersMap, {
          center: {
            lat: pin.location.latitude,
            lng: pin.location.longitude,
          },
        });
      }
    }
  };

  if (!pin || !menuItemKey) {
    return null;
  }

  return (
    <a onClick={handleClick} className={styles.link}>
      {children}
    </a>
  );
};
